import { render, staticRenderFns } from "./UploadCard.vue?vue&type=template&id=d525ec0c&scoped=true&lang=pug&"
import script from "./UploadCard.vue?vue&type=script&lang=js&"
export * from "./UploadCard.vue?vue&type=script&lang=js&"
import style0 from "./UploadCard.vue?vue&type=style&index=0&id=d525ec0c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d525ec0c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VSimpleTable})
